import Input$ from "@deosite/components-new/Input";
import { createComponent } from "@commerce-ui/core2";
import IconClose from "../../../icons/close.svg";

import formStyles from "../form-styles";
import React from "react";

const Input = createComponent(Input$, {
  ...formStyles,
  $clearElement: <IconClose style={{ display: "block" }} />,
  $rightEnhancersContainer: ({ invalid }) => ({
    $gutter: "8px",
    pr: 10,
    display: invalid ? "static" : "none",
    fill: invalid ? "negative" : "main"
  })
});

Input.labelInside = true;

export default Input;
